import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import indiamart from "../../../Assets/image/indiamart-logo-png_seeklogo-349456-removebg-preview.png";
import justdial from "../../../Assets/image/justdial-logo-png_seeklogo-32443-removebg-preview.png";
import logo from "../../../Assets/image/SEA_Logo_White_Text2.png";
import { ReactComponent as Google } from "../../../Assets/svg/round/google-chrome-svgrepo-com.svg";
import { ReactComponent as Facebook } from "../../../Assets/svg//round/facebook-svgrepo-com.svg";
import { ReactComponent as Linkdin } from "../../../Assets/svg/round/linkedin-round-svgrepo-com.svg";
import { ReactComponent as InstaIcon } from "../../../Assets/svg/round/instagram-svg.svg";
import { ReactComponent as Youtube } from "../../../Assets/svg/round/youtube-round-svgrepo-com.svg";
import "./footer.css"; // Ensure the CSS is correctly linked
import { Link } from "react-router-dom";
import {
    BsFacebook,
    BsGoogle,
    BsYoutube,
    BsLinkedin,
    BsInstagram,
} from "react-icons/bs";
import { FaThreads } from "react-icons/fa6";
import { SiGoogleplay, SiAppstore } from "react-icons/si";

// Import animatedata from external file

const footer = () => {

    return (
        <div className="footer">
            <footer class="text-slate-500">
                <div class="pt-8 pb-1 text-sm border-t border-slate-200 ">
                    <div class="container-footer px-0 mx-auto ">
                        <div class="grid grid-cols-4 gap-6 md:grid-cols-10 lg:grid-cols-12 footer_first_low">
                            <div class="col-span-6 md:col-span-6 lg:col-span-4 pl-2 parentDIV" aria-labelledby="footer-header">
                                <div className="flex align-content-center align-items-center footer_img_name gap-4">
                                    <a id="WindUI-5-logo" aria-label="WindUI logo" aria-current="page" class="flex items-center gap-2  text-base font-medium leading-6 whitespace-nowrap text-slate-700 focus:outline-none" href="javascript:void(0)">
                                        <img src={logo} alt="Logo" className="responsive-logo" style={{ height: '40px', width: '80px' }} viewBox="0 0 300 300" fill="none" class="shrink-0" />
                                    </a>
                                    <h6 className="foot-comName">
                                        Sandip electronics  And Automation
                                    </h6>
                                </div>
                                <p className="text-field mt-5">"At SEA, we are dedicated to delivering innovative and reliable products that power a smarter tomorrow.
                                    With a focus on quality and sustainability, we bring advanced technology to meet the diverse needs of our customers.
                                    Explore our product categories and discover solutions designed to enhance your world."</p>
                                <p className="text-field mt-2">Address:
                                    S No 116, R Cube, Office No 211, AtulNagar Phase I,
                                    Warje, Pune, Maharashtra 411058
                                </p>
                                <p className="text-field mt-1">
                                    Support Mail :-
                                    support@seaiot.in
                                </p>
                            </div>
                            <nav class="col-span-2 md:col-span-4 lg:col-span-2 pl-4 sm:pl-2" aria-labelledby="footer-product-5-logo">
                                <h3 class="mb-6 text-base font-medium text-slate-700" id="footer-product-5-logo">Getting Started</h3>
                                <ul class="footerlist_link">
                                    <li class="mb-2 leading-6">
                                        <a href="/OurStory" class="footer-link transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Our Story </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="https://docs.seaiot.in/books" target="_blank" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Documentation </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/featuresPage" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Features </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/WhyUs" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Why us? </a>
                                    </li>
                                    {/* <li class="mb-2 leading-6">
                                        <a href="javascript:void(0)" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Pricing </a>
                                    </li> */}
                                </ul>
                            </nav>
                            <nav class="col-span-2 md:col-span-4 lg:col-span-2 pl-4 sm:pl-2 " aria-labelledby="footer-docs-5-logo">
                                <h3 class="mb-6 text-base font-medium text-slate-700" id="footer-docs-5-logo">Company</h3>
                                <ul class="footerlist_link">
                                    <li class="mb-2 leading-6">
                                        <a href="/about" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> About Us</a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/solution" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Solutions </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/faq" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> FAQ's </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/casestudy" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Case Study </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/contact" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600">Contact Us</a>
                                    </li>
                                </ul>
                            </nav>
                            <nav class="col-span-2 md:col-span-3 lg:col-span-2 pl-4 sm:pl-2 " aria-labelledby="footer-about-5-logo">
                                <h3 class="mb-6 text-base font-medium text-slate-700" id="footer-about-5-logo">Resources</h3>
                                <ul class="footerlist_link">
                                    <li class="mb-2 leading-6">
                                        <a href="/customerstories" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Customer Stories </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/blogPage" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Blogs </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/eventsPage" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Events </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="/support" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Support</a>
                                    </li>
                                </ul>
                            </nav>
                            <div class="col-span-4 md:col-span-3 lg:col-span-2 pl-4 sm:pl-2 p-3" aria-labelledby="footer-about-5-logo">
                                <div className="gap-5 grid-logoimg" style={{ display: 'flex', alignItems: 'center' }}>
                                    <a id="WindUI-5-logo" aria-label="WindUI logo" aria-current="page" target="_blank"
                                        href="https://www.indiamart.com/sandip-electronicsautomation-sea/profile.html?srsltid=AfmBOorGrzcsz-eQvvsWUj4gDhzFXUgXU2KEPEUE-esyBNwM5KsZiZHU"
                                        title="Visit Sandip Electronics And Automation on IndiaMART"
                                    >
                                        <img src={indiamart} alt="sea-indiamart" className="" style={{ height: 'auto', width: '75px' }} viewBox="0 0 300 300" fill="none" class="shrink-0" />
                                    </a>
                                    <a id="WindUI-5-logo" aria-label="WindUI logo" aria-current="page" target="_blank"
                                        href="https://www.justdial.com/Pune/Sea-Sandip-Electronics-And-Automation-Warje/020PXX20-XX20-250221010320-T6N5_BZDET"
                                        title="Visit Sandip Electronics And Automation on Justdial">
                                        <img src={justdial} alt="sea-justdial" className="" style={{ height: 'auto', width: '90px' }} viewBox="0 0 300 300" fill="none" class="shrink-0" />
                                    </a>
                                </div>
                                <div className="slider-container-text">
                                    <div className="slider-track-1">
                                        <p className="slider-text-1">
                                            Our Services and product also Available on IndiaMART and Justdial
                                            &nbsp;||&nbsp;
                                            Our Services and product also Available on Justdial and IndiaMART
                                        </p>

                                        <p className="slider-text-1">
                                            Our Services and product also Available on IndiaMART and Justdial
                                            &nbsp;||&nbsp;
                                            Our Services and product also Available on Justdial and IndiaMART
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* <nav class="col-span-2 md:col-span-4 lg:col-span-2" aria-labelledby="footer-get-in-touch-5-logo">
                                <h3 class="mb-6 text-base font-medium text-slate-700" id="footer-get-in-touch-5-logo">Get in touch</h3>
                                <ul style={{color:'#003b45'}}>
                                    <li class="mb-2 leading-6">
                                        <a href="/contact" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Contact </a>
                                    </li>

                                    <li class="mb-2 leading-6">
                                        <Link to="/support" className="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600">
                                            Support
                                        </Link>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="javascript:void(0)" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Partners </a>
                                    </li>
                                    <li class="mb-2 leading-6">
                                        <a href="javascript:void(0)" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Join research </a>
                                    </li>
                                </ul>
                            </nav> */}
                        </div>
                    </div>
                </div>
                <div class="py-4 text-sm  border-slate-200 ">
                    <div class="container-footer px-2 mx-auto">
                        <div class="grid items-center grid-cols-4 md:grid-cols-8 lg:grid-cols-12">
                            <nav class="col-span-4 md:col-span-4 lg:col-span-8 flex align-center gap-5 justify-start" aria-labelledby="subfooter-links-3-sub">
                                {/* <h3 class="sr-only" id="subfooter-links-3-sub">Get in touch</h3> */}
                                <ul class="flex flex-wrap items-center justify-start gap-2 lg:gap-4 end-ul" >
                                    <li class="leading-6">
                                        <a href="/TermsOfUse" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Terms & Condition's </a>
                                    </li>
                                    |
                                    <li class="leading-6">
                                        <a href="/privacyPolicy" class="transition-colors duration-300 hover:text-emerald-500 focus:text-emerald-600"> Privacy Policy</a>
                                    </li>
                                </ul>
                                <div class="copyright">&copy;  SEA 2026</div>
                            </nav>
                            <div class="col-span-4 md:col-span-4 lg:col-span-4 justify-self-end">
                                <div>
                                    <div className="footer-icons">
                                        <a href="https://www.instagram.com/sea_solar_pump_controller/?igsh=YmFicWxtdW42OHBl#" target="_blank" rel="noopener noreferrer">
                                            <InstaIcon
                                                className="w-8 h-7 shrink-0 linkdin-icon"
                                                alt="SEA Instagram"
                                            />
                                        </a>
                                        <a href="https://www.facebook.com/share/1CcKRoRQn6/" target="_blank" rel="noopener noreferrer">
                                            <Facebook
                                                className="w-8 h-7 shrink-0 linkdin-icon"
                                                alt="SEA facebook"
                                            />
                                        </a>
                                        <a href="https://in.linkedin.com/in/sandip-electronics-and-automation-sea-a880b1344" target="_blank" rel="noopener noreferrer">
                                            <Linkdin
                                                className="w-8 h-7 shrink-0 linkdin-icon"
                                                alt="SEA linkdin"
                                            />
                                        </a>
                                        <a href="https://youtube.com/@solar796?si=HBUgmspwblCKEndF" target="_blank" rel="noopener noreferrer">
                                            <Youtube
                                                className="w-8 h-7 shrink-0 linkdin-icon"
                                                alt="SEA youtube"
                                            />
                                        </a>
                                        {/* <a href="https://www.threads.com/@sea_solar_pump_controller" target="_blank" rel="noopener noreferrer">
                                            <FaThreads style={{ fill: 'black', height: '30px', width: '20px', marginLeft: '5px' }} />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default footer;
